<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/system/auth/menu/treeList" getKey="rows" :columns="columns" @expandChange="expandChange" :lazy="true" :load="lazyLoad">
      <template #conditions>
        <!-- label-width="68px" -->
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xitongpingtai')">
            <yi_dictionary_select :type="'SYSTEM_AUTH_MENU_PLATFORM'" :ids.sync="yt.conditions.platform"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('caidanmingcheng')">
            <el-input size="mini" type="text" v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('caidanbianma')">
            <el-input size="mini" type="text" v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, beforeGet, afterReq)" type="primary" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear({ platform: '2' })">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t("xinzeng") }}
        </el-button>
        <el-button size="mini"  @click="initFrontConfig" :loading="initFrontConfigLoading">
          {{ $t("shuaxinpagesjson") }}
        </el-button>
      </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')">{{ $t("bianji") }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/system/auth/menu/delete')">{{ $t("shanchu") }}</el-button>
          </el-col>
        </el-row>
      </template>

      <template #footer>
        <!-- 这里可以在底部填写东西 -->
      </template>
    </yi_curd_table>

    <el-dialog class="abow_dialog" :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
      <!-- 新增弹窗 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller-form">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('caidanleixing')" required>
              <yi_dictionary_select :type="'SYSTEM_AUTH_MENU_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
            </el-form-item>
            <template v-if="yt.editObj.type == 1">
              <el-form-item :label="$t('suoshupingtai')" required>
                <yi_dictionary_select :type="'SYSTEM_AUTH_MENU_PLATFORM'" :ids.sync="yt.editObj.platform"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shangjicaidan')">
                <yi_cascader :id.sync="yt.editObj.parentId" :list="cascaderList(yt.editObj.platform)"> </yi_cascader>
              </el-form-item>

              <el-form-item :label="$t('caidanbianma')" required>
                <el-input v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('caidanmingcheng')" required>
                <el-input v-model="yt.editObj.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('caidantubiao')">
                <el-input v-model="yt.editObj.icon"></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianshipaixu')" required>
                <el-input v-model="yt.editObj.priority"></el-input>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('luyoudizhi')">
                <el-input v-model="yt.editObj.route"></el-input>
              </el-form-item>
              <el-form-item :label="$t('zujiandizhi')">
                <el-input v-model="yt.editObj.component"></el-input>
              </el-form-item>
              <el-form-item :label="$t('zujianbiaoshi')">
                <el-input v-model="yt.editObj.componentName"></el-input>
              </el-form-item>
              <el-form-item :label="$t('quanxianbiaoshi')">
                <el-input type="textarea" v-model="yt.editObj.perms"></el-input>
              </el-form-item>
              <el-form-item :label="$t('qingqiuyingshelujing')">
                <el-input v-model="yt.editObj.requestUrl"></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianshizhuangtai')" required>
                <el-select filterable :clearable="true" v-model="yt.editObj.visible">
                  <el-option :key="'xianshi'" :label="$t('xianshi')" :value="true"></el-option>
                  <el-option :key="'yincang'" :label="$t('yincang')" :value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('caidanzhuangtai')" required>
                <el-select :popper-append-to-body="false" filterable :clearable="true" v-model="yt.editObj.enabled">
                  <el-option :key="'zhengchang'" :label="$t('zhengchang')" :value="true"></el-option>
                  <el-option :key="'tingyong'" :label="$t('tingyong')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>

            <template v-if="yt.editObj.type == 2">
              <el-form-item :label="$t('suoshupingtai')" required>
                <yi_dictionary_select :type="'SYSTEM_AUTH_MENU_PLATFORM'" :ids.sync="yt.editObj.platform"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shangjicaidan')" v-if="yt.editObj.platform">
                <yi_cascader :id.sync="yt.editObj.parentId" :list="cascaderList(yt.editObj.platform)"> </yi_cascader>
              </el-form-item>

              <el-form-item :label="$t('caidanbianma')" required>
                <el-input v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('caidanmingcheng')" required>
                <el-input v-model="yt.editObj.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianshipaixu')" required>
                <el-input v-model="yt.editObj.priority"></el-input>
              </el-form-item>
              <el-form-item :label="$t('quanxianbiaoshi')">
                <el-input type="textarea" v-model="yt.editObj.perms"></el-input>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('qingqiuyingshelujing')">
                <el-input v-model="yt.editObj.requestUrl"></el-input>
              </el-form-item>
            </template>
          </el-form>
        </div>
        <!--注意，el-dialog的slot不能写成#footer-->
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/system/auth/menu/create', beforeAdd, afterAddOrUpdate)" type="primary">{{ $t("baocun") }} </el-button>
        </template>
      </template>
      <!-- 编辑弹窗 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller-form">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('caidanleixing')" required>
              <yi_dictionary_select :type="'SYSTEM_AUTH_MENU_TYPE'" :ids.sync="yt.editObj.type" disabled> </yi_dictionary_select>
            </el-form-item>
            <template v-if="yt.editObj.type == 1">
              <el-form-item :label="$t('suoshupingtai')" required>
                <yi_dictionary_select :type="'SYSTEM_AUTH_MENU_PLATFORM'" disabled :ids.sync="yt.editObj.platform"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shangjicaidan')">
                <yi_cascader :id.sync="yt.editObj.parentId" :list="cascaderList(yt.editObj.platform)" disabled> </yi_cascader>
              </el-form-item>

              <el-form-item :label="$t('caidanbianma')" required>
                <el-input v-model="yt.editObj.code" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('caidanmingcheng')" required>
                <el-input v-model="yt.editObj.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('caidantubiao')">
                <el-input v-model="yt.editObj.icon"></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianshipaixu')" required>
                <el-input v-model="yt.editObj.priority"></el-input>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('luyoudizhi')">
                <el-input v-model="yt.editObj.route"></el-input>
              </el-form-item>
              <el-form-item :label="$t('zujiandizhi')">
                <el-input v-model="yt.editObj.component"></el-input>
              </el-form-item>
              <el-form-item :label="$t('zujianbiaoshi')">
                <el-input v-model="yt.editObj.componentName"></el-input>
              </el-form-item>
              <el-form-item :label="$t('quanxianbiaoshi')">
                <el-input type="textarea" v-model="yt.editObj.perms"></el-input>
              </el-form-item>
              <el-form-item :label="$t('qingqiuyingshelujing')">
                <el-input v-model="yt.editObj.requestUrl"></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianshizhuangtai')" required>
                <el-select filterable :clearable="true" v-model="yt.editObj.visible">
                  <el-option :key="'xianshi'" :label="$t('xianshi')" :value="true"></el-option>
                  <el-option :key="'yincang'" :label="$t('yincang')" :value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('caidanzhuangtai')" required>
                <el-select :popper-append-to-body="false" filterable :clearable="true" v-model="yt.editObj.enabled">
                  <el-option :key="'zhengchang'" :label="$t('zhengchang')" :value="true"></el-option>
                  <el-option :key="'tingyong'" :label="$t('tingyong')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>

            <template v-if="yt.editObj.type == 2">
              <el-form-item :label="$t('suoshupingtai')" required>
                <yi_dictionary_select :type="'SYSTEM_AUTH_MENU_PLATFORM'" disabled :ids.sync="yt.editObj.platform"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shangjicaidan')" v-if="yt.editObj.platform">
                <yi_cascader :id.sync="yt.editObj.parentId" :list="cascaderList(yt.editObj.platform)" disabled> </yi_cascader>
              </el-form-item>

              <el-form-item :label="$t('caidanbianma')" required>
                <el-input v-model="yt.editObj.code" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('caidanmingcheng')" required>
                <el-input v-model="yt.editObj.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianshipaixu')" required>
                <el-input v-model="yt.editObj.priority"></el-input>
              </el-form-item>
              <el-form-item :label="$t('quanxianbiaoshi')">
                <el-input type="textarea" v-model="yt.editObj.perms"></el-input>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('qingqiuyingshelujing')">
                <el-input v-model="yt.editObj.requestUrl"></el-input>
              </el-form-item>
            </template>
          </el-form>
        </div>
        <!--注意，el-dialog的slot不能写成#footer-->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/system/auth/menu/update', beforeUpdate, afterAddOrUpdate)" type="primary">{{ $t("baocun") }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "admin_global_menu_list",
  components: {},
  mixins: [],
  data() {
    return {
      initFrontConfigLoading: false,
      backUpList: [],
      menus: [],
      columns: [
        {
          label: "caidanmingcheng",
          prop: "name",
          width: 130,
        },
        {
          label: "caidanbianma",
          prop: "code",
          width: 130,
        },
        {
          label: "caidanleixing",
          prop: "type",
          type: "dictionary",
          key: "SYSTEM_AUTH_MENU_TYPE",
        },
        {
          label: "paixu",
          prop: "priority",
        },
        {
          label: "beizhu",
          prop: "remark",
        },
        {
          label: "quanxianbiaoshi",
          prop: "perms",
        },
        {
          label: "zujianluyou",
          prop: "component",
        },
        {
          label: "luyoudizhi",
          prop: "route",
        },
        {
          label: "zhuangtai",
          prop: "enabled",
          type: "bool",
          iln18: ["zhengchang", "yincang"],
        },
        {
          label: "tubiao",
          prop: "icon",
        },
        {
          label: "chuangjianshijian",
          prop: "createTime",
          type: "time",
        },
        {
          label: "caozuo",
          type: "slot",
          width: 130,
          fixed: "right",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        platform: "2",
      };
      //this.yt.pageNum = 1//默认就是1
      this.yt.pageSize = 999;
      this.yt.isShowPagination = false;
      this.yt.get(1, this.beforeGet, this.afterReq);

      this.getAllPlatformMenus();
    }, 300);
  },
  mounted() {},

  destroyed() {},

  computed: {
    cascaderList() {
      return function(platform) {
        //目前只有两级，所以不用无限嵌套写法，单纯判断两级即可
        if (!this.menus[platform - 1]) {
          return [];
        }
        return this.menus[platform - 1].map((item) => {
          let children = [];
          if (item.children) {
            children = item.children.map((item2) => {
              return {
                label: this.$t(item2.code),
                value: item2.id,
                type: item2.type,
              };
            });
          }

          //把“功能”去掉
          for (var i = 0; i < children.length; i++) {
            if (children[i].type == 2) {
              children.splice(i, 1);
              i--;
            }
          }

          if (children.length == 0) {
            children = null;
          }

          return {
            label: this.$t(item.code),
            value: item.id,
            children: this.yt.editObj.type == 1 ? null : children, //如果是添加菜单，那么就只能一级，如果是添加按钮，就是二级
          };
        });
      };
    },
  },
  activated() {},
  methods: {
    initFrontConfig(){
      this.initFrontConfigLoading = true;
      this.http.get("web/frontend/pages/routes/config/refreshFrontendRoutesConfig",null)
      .then((res) => {
        this.utils.successMessage(this.$t(res.msg));
      }).finally(()=>{
        this.initFrontConfigLoading = false;
      });
    },
    // reset() {
    // 	this.yt.conditions = {
    // 		platform: "2",
    // 	}
    // },
    afterReq(result) {
      //先备份完整list
      this.backUpList = this.utils.copy(result.data.rows);
      for (let index = 0; index < this.backUpList.length; index++) {
        if (this.backUpList[index].children) {
          this.backUpList[index].hasChildren = true;
          for (let index2 = 0; index2 < this.backUpList[index].children.length; index2++) {
            if (this.backUpList[index].children[index2].children) {
              this.backUpList[index].children[index2].hasChildren = true;
            }
          }
        }
      }

      //然后把list的children删掉
      for (let index = 0; index < result.data.rows.length; index++) {
        if (result.data.rows[index].children) {
          result.data.rows[index].children = null;
          result.data.rows[index].hasChildren = true;
        }
      }
      console.log(result);
      return result;
    },
    lazyLoad(tree, treeNode, resolve) {
      for (let index = 0; index < this.backUpList.length; index++) {
        if (this.backUpList[index].code == tree.code) {
          return resolve(this.backUpList[index].children);
        }

        if (this.backUpList[index].children) {
          for (let index2 = 0; index2 < this.backUpList[index].children.length; index2++) {
            if (this.backUpList[index].children[index2].code == tree.code) {
              return resolve(this.backUpList[index].children[index2].children);
            }
          }
        }
      }
    },

    expandChange(a, b) {
      console.log(a, b);
    },
    // get remove  req

    //重构这个函数，正常返回请求参数，不通过就返回false
    beforeGet(params) {
      if (!params.platform) {
        this.utils.errorMessage(this.$t("qingxuanzepingtaileixing"));
        return false;
      }

      return params;
    },

    beforeAdd(params) {
      //是否外链这个是隐藏的，所以我们默认设置为false
      params.frame = false;
      return params;
    },
    beforeUpdate(params) {
      //是否外链这个是隐藏的，所以我们默认设置为false
      params.frame = false;
      return params;
    },
    afterAddOrUpdate() {
      this.getAllPlatformMenus();
      this.yt.isShowEditDialog = false;
      this.yt.get(1, this.beforeGet);
    },
    getAllPlatformMenus() {
      //先查询出所有平台的菜单
      this.menus = new Array(5);
      for (var i = 0; i < 4; i++) {
        ((i) => {
          this.http
            .get("web/system/auth/menu/treeList", {
              params: {
                platform: i + 1,
              },
            })
            .then((res) => {
              this.menus[i] = res.data.rows;
            });
        })(i);
      }
    },
  },
};
</script>
